import { API_URL } from "@/shared/config/env";
import axios from "axios";
import { setupInterceptors } from "./interceptors";

const api = axios.create({
  baseURL: API_URL,
});

setupInterceptors(api);

export default api;
